import { render, staticRenderFns } from "./DocumentElement.vue?vue&type=template&id=a2ffd4b2&lang=pug"
import script from "./DocumentElement.vue?vue&type=script&lang=js"
export * from "./DocumentElement.vue?vue&type=script&lang=js"
import style0 from "./DocumentElement.vue?vue&type=style&index=0&id=a2ffd4b2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports